export default __webpack_public_path__ + "static/media/Teachersday3.eaaf545d.JPG";